<template>
  <v-app>
    <v-container
      v-if="fullPageLoading"
      fluid
      style="
        height: 100vh;
        width: 100%;
        padding: 0;
        background-color: white;
        overflow: hidden;
        border-radius: 10px;
      "
    >
      <HomePageSkeleton />
    </v-container>
    <div v-else class="main-div" style="overflow-y: hidden; height: 100vh">
      <v-list v-if="drawer" class="app-bar" dark>
        <div class="d-flex align-center pa-2">
          <img :src="logo" alt="logo" style="height: 25px" />
        </div>

        <div
          width="282"
          style="background-color: transparent; position: relative"
          class="operator-search-main"
          v-click-outside="handleClickOutside"
        >
          <v-text-field
            ref="searchInputWrapper"
            outlined
            dense
            hide-details
            :class="`operator-search ${
              extraOperators?.length > 0 && openSearchResultList
                ? 'show-extra-search-result'
                : ''
            } ${onFocusOperatorSearch ? 'on-focus-operator-search' : ''}`"
            v-model="searchOperator"
            placeholder="座席番号を検索する"
            @focus="handleFocusSearch"
            clearable
            clear-icon="mdi-close"
            @click:clear="handleClear"
          />

          <!-- Extra Floating List (Overlay) -->
          <v-list
            ref="searchListWrapper"
            v-if="openSearchResultList"
            class="extra-search-list"
          >
            <v-list-item
              v-for="(item, idx) in extraOperators"
              :key="idx"
              class="extra-result-v-list"
            >
              <v-list-item-content class="extra-result-list-item">
                <v-list-item-title
                  class="d-flex justify-space-between align-center"
                  @click="toggleSelection(item)"
                >
                  <div
                    v-html="
                      highlightMatch(item.dest_phone_name, searchOperator)
                    "
                  ></div>
                  <!-- <span>{{ item.dest_phone_name }}</span> -->
                  <v-icon v-if="isSelected(item)" color="green" small>
                    mdi-check
                  </v-icon>
                </v-list-item-title>
                <!-- <v-list-item-subtitle>{{ item.info }}</v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item
            :class="`operator-list-item ${!selectedOperator && 'hover'} ${
              selectedItems?.length > 0 && 'hover'
            }`"
            @click="handleClear"
            style="width: 90%; padding: 0px 16px !important"
          >
            <v-list-item-content>
              <v-list-item-content>
                {{
                  selectedItems?.length > 0
                    ? "電話機一覧"
                    : `すべて (オペレーター${operators.length}名)`
                }}
              </v-list-item-content>
            </v-list-item-content>
          </v-list-item>
          <v-list dense dark class="operator-list">
            <v-list-item
              :class="`operator-list-item ${
                selectedOperator === operator.dest_phone_name && 'hover'
              }`"
              v-for="(operator, index) in operators"
              :key="index"
            >
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <div>
                    <v-list-item-title>{{
                      operator.dest_phone_name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      operator.dest_ip_address
                    }}</v-list-item-subtitle>
                  </div>
                  <v-icon
                    v-if="isSelected(operator)"
                    small
                    @click="toggleSelection(operator)"
                    class="position-absolute end-0 me-3"
                    >mdi-close</v-icon
                  >
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-list>

      <!-- Mobile Drawer -->
      <v-navigation-drawer
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="mobileDrawer"
        temporary
        fixed
        dark
        class="mobile-drawer"
      >
        <div class="d-flex align-center pa-3 justify-space-between">
          <img :src="logo" alt="logo" style="height: 25px" />
          <v-btn icon @click="mobileDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div
          width="282"
          style="background-color: transparent; position: relative"
          class="operator-search-main"
          v-click-outside="handleClickOutside"
        >
          <v-text-field
            ref="searchInputWrapperMobileDrawer"
            outlined
            dense
            hide-details
            :class="`operator-search ${
              extraOperators?.length > 0 && openSearchResultList
                ? 'show-extra-search-result'
                : ''
            } ${onFocusOperatorSearch ? 'on-focus-operator-search' : ''}`"
            v-model="searchOperator"
            placeholder="座席番号を検索する"
            @focus="handleFocusSearch"
            clearable
            clear-icon="mdi-close"
            @click:clear="handleClear"
          />

          <v-list
            ref="searchListWrapperMobileDrawer"
            v-if="openSearchResultList"
            class="extra-search-list"
          >
            <v-list-item
              v-for="(item, idx) in extraOperators"
              :key="idx"
              class="extra-result-v-list"
            >
              <v-list-item-content class="extra-result-list-item">
                <v-list-item-title
                  class="d-flex justify-space-between align-center"
                  @click="toggleSelection(item)"
                >
                  <div
                    v-html="
                      highlightMatch(item.dest_phone_name, searchOperator)
                    "
                  ></div>
                  <v-icon v-if="isSelected(item)" color="green" small>
                    mdi-check
                  </v-icon>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item
            :class="`operator-list-item ${!selectedOperator && 'hover'} ${
              selectedItems?.length > 0 && 'hover'
            }`"
            @click="handleClear"
            style="width: 90%; padding: 0px 16px !important"
          >
            <v-list-item-content>
              <v-list-item-content>
                {{
                  selectedItems?.length > 0
                    ? "電話機一覧"
                    : `すべて (オペレーター${operators.length}名)`
                }}
              </v-list-item-content>
            </v-list-item-content>
          </v-list-item>

          <div class="mobile-operator-search-main">
            
          <v-list dense dark class="operator-list mobile-operator-list">
            <v-list-item
              :class="`operator-list-item ${
                selectedOperator === operator.dest_phone_name && 'hover'
              }`"
              v-for="(operator, index) in operators"
              :key="index"
            >
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <div>
                    <v-list-item-title>{{
                      operator.dest_phone_name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      operator.dest_ip_address
                    }}</v-list-item-subtitle>
                  </div>
                  <v-icon
                    v-if="isSelected(operator)"
                    small
                    @click="toggleSelection(operator)"
                    class="position-absolute end-0 me-3"
                    >mdi-close</v-icon
                  >
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </div>
        </div>
      </v-navigation-drawer>

      <div class="main-section" :class="{ 'mobile-main-section': $vuetify.breakpoint.smAndDown }">
        <v-container fluid>
          <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            :color="snackbarColor"
            top
          >
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
              <v-btn
                text
                v-bind="attrs"
                @click="snackbar = false"
                class="pa-0 ma-0"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <div class="main-header py-2 px-0 border-bottom-lightblue">
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center justify-start">
                <div class="me-2">
                  <v-btn v-if="$vuetify.breakpoint.smAndDown"  icon @click="mobileDrawer = !mobileDrawer">
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                  <v-btn v-else icon color="primary" @click="refreshCallList">
                    <img :src="refreshSVG" alt="" />
                  </v-btn>
                </div>
                <div style="border-right: 1px solid #aaaaaa; height: 20px"></div>
                <div class="ms-2">
                  <p class="table-title">すべての顧客セッション</p>
                  <p class="table-subtitle">すべての顧客セッションの詳細リスト</p>
                </div>
              </div>
              <v-menu offset-y v-if="$vuetify.breakpoint.smAndDown">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="profile-menu-btn">
                    <v-avatar size="32">
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item disabled>
                    <v-list-item-content>
                      <v-list-item-title class="primary--text font-weight-bold"
                        >{{ userProfile?.first_name }}
                        {{ userProfile?.middle_name }}
                        {{ userProfile?.last_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="blackDark--text">{{
                        userProfile?.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="logout">
                    <span class="me-2">
                      <v-icon>mdi-logout</v-icon>
                    </span>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div :class="['d-flex','align-center', $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row']">
              <template>
                <div v-if="isAdmin" class="d-flex align-center">
                  <span class="mr-2"> N/Aコールを表示 </span>
                  <v-switch
                    v-model="toggleNaSwitch"
                  ></v-switch>
                </div>
                <div class="bar mx-2" v-if="!$vuetify.breakpoint.xsOnly"></div>
                <div v-if="isAdmin && selectedCalls.length" class="delete-call-details"
                  @click="deleteBulkDialog = true" :style="$vuetify.breakpoint.xsOnly ? 'margin-bottom: 8px;' : ''">
                  <img :src="deleteIcon" alt="delete" class="cursor-pointer" />
                  <span class="delete-btn">削除 ({{ selectedCalls.length }})</span>
                </div>
                <div class="bar mx-2" v-if="!$vuetify.breakpoint.xsOnly && isAdmin && selectedCalls.length"></div>
                <v-card
                  flat
                  class="pa-1 d-flex align-center justify-space-between"
                  :style="$vuetify.breakpoint.xsOnly
                    ? 'background-color: #f8f9fa; width: 100%; height: 40px; margin-bottom: 8px'
                    : $vuetify.breakpoint.smOnly
                    ? 'background-color: #f8f9fa; width: 100%; height: 40px'
                    : 'background-color: #f8f9fa; width: 260px; height: 40px'"
                >
                  <!-- Search Icon -->
                  <v-icon class="ms-3 me-2" size="20">mdi-magnify</v-icon>

                  <!-- Input -->
                  <input
                    ref="searchField"
                    v-model="searchText"
                    class="search-input"
                    type="text"
                    prepend-inner-icon="mdi-magnify"
                    hide-details
                    outlined
                    dense
                    clearable
                    @keydown="handleSearch"
                    @compositionstart="isComposing = true"
                    @compositionend="isComposing = false"
                    placeholder="すべての情報から探す"
                    style="flex:1; min-width:0; border:none; outline:none; background:transparent"
                  />

                  <!-- Filter Button -->
                  <v-btn
                    icon
                    size="small"
                    variant="text"
                    class="search-filter-btn"
                    @click="openFilter"
                  >
                    <v-icon>mdi-tune</v-icon>
                  </v-btn>
                </v-card>
              </template>
              <!-- <input
                ref="searchField"
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                hide-details
                outlined
                dense
                clearable
                @keydown="handleSearch"
                @compositionstart="isComposing = true"
                @compositionend="isComposing = false"
                placeholder="すべての情報から探す"
                class="search-call"
              /> -->
              <div class="mx-2 bar" v-if="!$vuetify.breakpoint.xsOnly"></div>
              <v-menu
                offset-y
                :style="$vuetify.breakpoint.xsOnly ? 'width:100%; margin-bottom:8px' : $vuetify.breakpoint.smOnly ? 'width:calc(50% - 8px)' : 'width:200px'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="call-filter align-center d-flex mt-2 mt-sm-0"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    :style="$vuetify.breakpoint.xsOnly ? 'width:100%' : $vuetify.breakpoint.smOnly ? 'width:100%' : 'width:200px'"
                  >
                    {{
                      callStatus.find(
                        (state) => state.value === selectedCallStatus
                      ).text
                    }}
                  </span>
                </template>
                <v-list class="call-filter-list">
                  <v-list-item
                    v-for="state in callStatus"
                    :key="state.value"
                    @click="selectedCallStatus = state.value"
                  >
                    <v-list-item-title>{{ state.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div
                class="mx-2 bar"
                v-if="showProjectSwitcher && !$vuetify.breakpoint.smAndDown"
              ></div>
              <ProjectSwitcher class="mt-2 mt-sm-0" />

              <div class="mx-2 bar" v-if="!$vuetify.breakpoint.smAndDown"></div>
              <v-menu offset-y v-if="!$vuetify.breakpoint.smAndDown">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="profile-menu-btn">
                    <v-avatar size="32">
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item disabled>
                    <v-list-item-content>
                      <v-list-item-title class="primary--text font-weight-bold"
                        >{{ userProfile?.first_name }}
                        {{ userProfile?.middle_name }}
                        {{ userProfile?.last_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="blackDark--text">{{
                        userProfile?.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="logout">
                    <span class="me-2">
                      <v-icon>mdi-logout</v-icon>
                    </span>
                    <v-list-item-title>ログアウト</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <template v-if="openSearchFilter">
            <div class="pa-2 mb-2 border-bottom-lightblue filter-field-section">
              <FilterFields
                :filters="filters"
                :fields="filterFields"
                @change="handleInputChange"
                @openFilter="openFilter"
              />
            </div>

            <!-- Table or result list below -->
          </template>
          <v-row class="">
            <v-col cols="12">
              <div class="call-table">
                <v-data-table
                  v-model="selectedCalls"
                  :show-select="isAdmin && (calls?.length > 0)"
                  item-key="session_id"
                  :headers="headers"
                  :items="calls"
                  :loading="loading"
                  :server-items-length="totalCalls"
                  @update:options="options = $event"
                  :options="options"
                  :footer-props="{
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true,
                  }"
                  hide-default-footer
                  no-data-text="データがありません"
                  class="custom-table-checkbox"
                >
                  <template v-slot:[`header.session_id`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                        width="14"
                        height="14"
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.call_id`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                        width="14"
                        height="14"
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.conversation_title`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                        width="14"
                        height="14"
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.date`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.call_time`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.caller`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.receiver`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.dest_phone_name`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.client_name`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.service_name`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.counselor_name`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`header.call_length`]="{ header }">
                    <div
                      class="table-header-custom-title d-flex justify-center align-center"
                    >
                      <div :class="headerActiveStatus(header.sortOrder)">
                        {{ header.text }}
                      </div>
                      <Icon
                        name="dropdown"
                        color="gray"
                        width="14"
                        height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="
                          header.sortOrder == 'desc' ? 'black' : 'gray'
                        "
                      />
                    </div>
                  </template>
                  <template v-slot:[`item.index`]="{ index }">
                    {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
                  </template>
                  <template v-slot:[`item.session_id`]="{ item }">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span
                            @click="copyToClipboard(item.session_id)"
                            class="cursor-pointer"
                          >
                            {{ item.session_id.slice(0, 8)
                            }}{{ item.session_id.length > 8 ? "..." : "" }}
                          </span>
                        </span>
                      </template>
                      <span>{{ item.session_id }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.call_id`]="{ item }">
                    <v-tooltip v-if="item.call_id" right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span
                            @click="copyToClipboard(item.call_id)"
                            class="cursor-pointer"
                          >
                            {{ item?.call_id.slice(0, 8)
                            }}{{ item?.call_id.length > 8 ? "..." : "" }}
                          </span>
                        </span>
                      </template>
                      <span>{{ item?.call_id }}</span>
                    </v-tooltip>
                    <span v-else>N/A</span>
                  </template>
                  <template v-slot:[`item.caller`]="{ item }">
                    <span>{{
                      handlePhoneNumberFormat(item?.src_id) || "N/A"
                    }}</span>
                  </template>
                  <template v-slot:[`item.receiver`]="{ item }">
                    <span>{{
                      handlePhoneNumberFormat(item?.dest_id) || "N/A"
                    }}</span>
                  </template>
                  <template v-slot:[`item.conversation_title`]="{ item }">
                    <v-tooltip right v-if="item?.conversation_title">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span class="cursor-pointer">
                            {{ item?.conversation_title.slice(0, 7) }}
                            {{
                              item?.conversation_title.length > 7 ? "..." : ""
                            }}
                          </span>
                        </span>
                      </template>
                      <span
                        style="
                          display: inline-block;
                          width: 250px;
                          white-space: normal;
                        "
                      >
                        {{ item?.conversation_title }}
                      </span>
                    </v-tooltip>
                    <span v-else>N/A</span>
                  </template>
                  <template v-slot:[`item.customer_id`]="{ item }">
                    <span>{{ item.src_ip_address }}:{{ item.src_port }}</span>
                  </template>
                  <template v-slot:[`item.dest_phone_name`]="{ item }">
                    <p class="ma-0 pa-0">
                      <span v-if="item?.dest_phone_name">
                        {{ item?.dest_phone_name }} - <br />
                        {{ item?.dest_model_name }}
                      </span>
                      <span v-else>N/A</span>
                    </p>
                  </template>
                  <template v-slot:[`item.client_name`]="{ item }">
                    <p class="ma-0 pa-0">
                      <v-tooltip right v-if="item?.client_info?.client_name">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <span class="cursor-pointer">
                              {{ item?.client_info?.client_name.slice(0, 7) }}
                              {{
                                item?.client_info?.client_name.length > 7
                                  ? "..."
                                  : ""
                              }}
                            </span>
                          </span>
                        </template>
                        <span
                          style="
                            display: inline-block;
                            width: 250px;
                            white-space: normal;
                          "
                        >
                          {{ item?.client_info?.client_name }}
                        </span>
                      </v-tooltip>
                      <span v-else>N/A</span>
                    </p>
                  </template>
                  <template v-slot:[`item.service_name`]="{ item }">
                    <p class="ma-0 pa-0">
                      <v-tooltip right v-if="item?.client_info?.service_name">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <span class="cursor-pointer">
                              {{ item?.client_info?.service_name.slice(0, 7) }}
                              {{
                                item?.client_info?.service_name.length > 7
                                  ? "..."
                                  : ""
                              }}
                            </span>
                          </span>
                        </template>
                        <span
                          style="
                            display: inline-block;
                            width: 250px;
                            white-space: normal;
                          "
                        >
                          {{ item?.client_info?.service_name }}
                        </span>
                      </v-tooltip>
                      <span v-else>N/A</span>
                    </p>
                  </template>
                  <template v-slot:[`item.counselor_name`]="{ item }">
                    <p class="ma-0 pa-0">
                      {{
                        item?.counselor_name ? item?.counselor_name : "N/A"
                      }}
                    </p>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    <span>{{
                      new Date(item.date).toLocaleDateString("en-CA")
                    }}</span>
                  </template>
                  <template v-slot:[`item.call_status`]="{ item }">
                    <span
                      :class="`call-status
                        ${
                          item.call_status === 'finished'
                            ? 'finished'
                            : item.call_type === 'incoming'
                            ? 'incoming'
                            : 'outgoing'
                        }`"
                    >
                      <img
                        v-if="item.call_type"
                        :src="
                          item.call_type === 'incoming'
                            ? incomingCallIcon
                            : item.call_type === 'outgoing'
                            ? outgoingCallIcon
                            : ''
                        "
                        alt="call type"
                        style="height: 16px; width: 16px"
                      />
                      <span>
                        {{ getDuration(item.start_time, item.end_time) }}
                      </span>
                    </span>
                    <p class="ma-0 text-caption">
                      {{
                        item.start_time
                          ? new Date(item.start_time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                          : "N/A"
                      }}
                      -
                      {{
                        item.end_time
                          ? new Date(item.end_time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                          : "録音中"
                      }}
                    </p>
                  </template>
                  <template v-slot:[`item.call_time`]="{ item }">
                   <div :class="$vuetify.breakpoint.smAndDown ? 'd-flex justify-start' : ''">
                    <span
                      :class="`call-status
                        ${
                          item.call_status === 'finished'
                            ? 'finished'
                            : item.call_type === 'incoming'
                            ? 'incoming'
                            : 'outgoing'
                        }`"
                    >
                      <img
                        v-if="item.call_type"
                        :src="
                          item.call_type === 'incoming'
                            ? incomingCallIcon
                            : item.call_type === 'outgoing'
                            ? outgoingCallIcon
                            : ''
                        "
                        alt="call type"
                        style="height: 16px; width: 16px"
                      />
                    </span>
                    <p class="ma-0 text-caption">
                      {{
                        item.start_time
                          ? new Date(item.start_time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                          : "N/A"
                      }}
                      -
                      {{
                        item.end_time
                          ? new Date(item.end_time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                          : "録音中"
                      }}
                    </p>
                   </div>
                  </template>
                  <template v-slot:[`item.call_length`]="{ item }">
                    <span
                      :class="`call-status
                        ${
                          item.call_status === 'finished'
                            ? 'finished'
                            : item.call_type === 'incoming'
                            ? 'incoming'
                            : 'outgoing'
                        }`"
                    >
                      <img
                        v-if="item.call_type"
                        :src="
                          item.call_type === 'incoming'
                            ? incomingCallIcon
                            : item.call_type === 'outgoing'
                            ? outgoingCallIcon
                            : ''
                        "
                        alt="call type"
                        style="height: 16px; width: 16px"
                      />
                      <span>
                        {{ getDuration(item.start_time, item.end_time) }}
                      </span>
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <div class="d-flex align-center">
                      <div
                        class="border pa-2 d-flex align-center cursor-pointer me-2"
                        @click="initiatedCall(item)"
                      >
                        <img
                          :src="eyeIcon"
                          alt="eye"
                          style="height: 18px; width: 18px"
                        />
                      </div>
                      <!-- <v-menu offset-y> -->
                      <template>
                        <div
                          v-if="callIndexDownloadLoader[index]"
                          class="border pa-2 d-flex align-center"
                        >
                          <v-progress-circular
                            indeterminate
                            size="15"
                            color="grey darken-1"
                          ></v-progress-circular>
                        </div>
                        <div
                          v-else
                          class="border pa-2 d-flex align-center"
                          :disabled="item.audio_file_path"
                          @click="downloadFile(item, index)"
                          target="_blank"
                          :class="`me-2 ${
                            item.audio_file_path ? 'cursor-pointer' : 'disabled'
                          } `"
                        >
                          <Icon
                            name="download"
                            :color="item.audio_file_path ? 'gray' : '#E2E8F0'"
                            width="14"
                            height="14"
                          />
                        </div>
                      </template>
                      <!-- <v-list class="table-more-options">
                          <v-list-item
                            :class="item.audio_file_path ? '' : 'disabled'"
                          >
                            <div v-if="presignedUrlLoader" class="me-2">
                              <v-progress-circular
                                indeterminate
                                size="15"
                                color="grey darken-1"
                              ></v-progress-circular>
                            </div>
                            <div
                              v-else
                              :disabled="item.audio_file_path"
                              @click="downloadFile(item)"
                              target="_blank"
                              :class="`me-2 ${
                                item.audio_file_path
                                  ? 'cursor-pointer'
                                  : 'disabled'
                              } `"
                            >
                              <v-icon
                                :class="
                                  item.audio_file_path
                                    ? 'cursor-pointer'
                                    : 'disabled'
                                "
                                >mdi-download</v-icon
                              >
                              ダウンロード
                            </div>
                          </v-list-item>
                          <v-list-item
                            @click="deleteCall(item.session_id)"
                            class="cursor-pointer"
                          >
                            <div>
                              <span class="error--text">
                                <v-icon color="error">mdi-delete</v-icon>
                                削除
                              </span>
                            </div>
                          </v-list-item>
                        </v-list> -->
                      <!-- </v-menu> -->
                    </div>
                  </template>
                  <template v-slot:footer>
                    <div class="footer-fixed">
                      <v-pagination
                        color="hover"
                        :total-visible="8"
                        v-model="options.page"
                        :length="Math.ceil(totalCalls / options.itemsPerPage)"
                        @input="getCallList"
                      ></v-pagination>
                      <div>
                        <span
                          >{{
                            pageRangePagination(
                              options.page,
                              options.itemsPerPage,
                              totalCalls
                            )
                          }}
                        </span>
                        <span>
                          <select
                            style="width: max-content; padding-right: 30px"
                            v-model="options.itemsPerPage"
                            class="call-filter"
                            @change="refreshCallList"
                          >
                            <option
                              class="call-filter-item"
                              v-for="item in [10, 25, 50, 100]"
                              :key="item"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </span>
                        <span> 件表示 </span>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- Delete Call Dialog -->
    <v-dialog v-model="deleteDialog" class="delete-dialog" width="448">
      <v-card>
        <v-card-title
          class="headline justify-space-between"
          style="font-size: 20px; font-weight: 500"
        >
          削除の確認
          <v-icon
            class="cursor-pointer"
            @click="
              deleteDialog = false;
              selectedSessionId = '';
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="delete-dialog-text">
          <img :src="trashCanIcon" alt="" style="height: 60px; width: 60px" />
          <p
            style="
              font-size: 15px;
              font-weight: 400;
              color: #3f4652;
              margin-top: 24px;
            "
          >
            この通話を削除しますか？
          </p>
        </v-card-text>
        <v-card-actions class="justify-space-around pb-5">
          <v-btn
            class="no-btn-delete"
            @click="
              deleteDialog = false;
              selectedSessionId = '';
            "
          >
            キャンセル
          </v-btn>
          <v-btn class="yes-btn-delete" @click="deleteCallFunction">
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete Bulk Call Dialog -->
    <v-dialog v-model="deleteBulkDialog" :persistent="isBulkDeleting" class="delete-dialog" width="448">
      <v-card>
        <v-card-title
          class="headline justify-space-between"
          style="font-size: 20px; font-weight: 500"
        >
          削除の確認
        </v-card-title>
        <v-card-text class="delete-dialog-text">
          <img :src="trashCanIcon" alt="" style="height: 60px; width: 60px" />
          <p
            style="
              font-size: 15px;
              font-weight: 400;
              color: #3f4652;
              margin-top: 24px;
            "
          >
            選択した{{ selectedCalls.length }}件の通話を削除しますか？
          </p>
        </v-card-text>
        <v-card-actions class="justify-space-around pb-5">
          <v-btn
            class="no-btn-delete"
            :disabled="isBulkDeleting"
            @click="deleteBulkDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn class="yes-btn-delete" :loading="isBulkDeleting" @click="deleteBulkCallsFunction">
            削除する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import dest_info from "@/helpers/Destination_Information";
import logo from "@/assets/images/maira_voice_logo.svg";
import refreshSVG from "@/assets/images/refresh.svg";
import eyeIcon from "@/assets/images/eye.svg";
import threeDotsIcon from "@/assets/images/three_dots.svg";
import incomingCallIcon from "@/assets/images/incoming.svg";
import outgoingCallIcon from "@/assets/images/outgoing.svg";
import trashCanIcon from "@/assets/images/trashCan.svg";
import deleteIcon from "@/assets/images/Delete.svg";
import HomePageSkeleton from "@/components/HomePageSkeleton.vue";
import downloadIcon from "@/assets/images/download.svg";
import downloadWhiteIcon from "@/assets/images/DownloadWhiteBackground.svg";
import FilterFields from "@/components/CallFilterFields.vue";
import ProjectSwitcher from "@/components/ProjectSwitcher.vue";
import callListMixin from "@/mixins/callListMixin";
import { debounce } from "@/utils/debounceFields";
import { Icon } from "@/assets/icons";
// import { ref } from 'vue'
import { findClientsFromSipData } from "@/helpers/Client_Information";
import {
  getCounselorNameBackfillPatch,
  getCounselorPhones,
} from "@/helpers/SoftPhone_Information";
import { interactionUpdate } from "@/helpers/helper";
import { INTERACTION_POINT } from "@/global/_constants";
export default {
  name: "HomePage",
  mixins: [callListMixin],

  components: {
    HomePageSkeleton,
    FilterFields,
    ProjectSwitcher,
    Icon,
  },
  computed: {
    ...mapGetters("account", ["userProfile", "isAdmin"]),
    ...mapGetters("project", ["activeProjectId", "showProjectSwitcher"]),
    ...mapState({
      user: (state) => state.account.user,
    }),
  },
  data() {
    return {
      getCounselorPhones,
      interactionUpdate,
      INTERACTION_POINT,
      deptOperators: [],
      fullPageLoading: false,
      drawer: true,
      mobileDrawer: false,
      isComposing: false,
      searchOperator: "",
      selectedOperator: null,
      logo,
      eyeIcon,
      deleteIcon,
      toggleNaSwitch: false,
      downloadIcon,
      downloadWhiteIcon,
      threeDotsIcon,
      incomingCallIcon,
      outgoingCallIcon,
      refreshSVG,
      trashCanIcon,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "",
      userTags: [],
      operators: [],
      extraOperators: "",
      callStatus: [
        { text: "録音中", value: "on_going" },
        { text: "完了", value: "finished" },
        { text: "すべて", value: "all" },
      ],
      selectedCallStatus: "on_going",
      searchText: "",
      headers: [
        { text: "No.", value: "index", sortable: false, class: "index-col", cellClass: "index-col", width: "4%" },
        { text: "管理番号", value: "session_id", sortable: true },
        { text: "コールID", value: "call_id", sortable: true },
        { text: "タイトル", value: "conversation_title", sortable: true },
        { text: "発信者", value: "caller", sortable: true },
        { text: "着信先", value: "receiver", sortable: true },
        { text: "電話機名", value: "dest_phone_name", sortable: true },
        { text: "クライアント名", value: "client_name", sortable: true },
        { text: "サービス名", value: "service_name", sortable: true },
        { text: "相談員氏名", value: "counselor_name", sortable: true },
        { text: "日付", value: "date", sortable: true },
        { text: "通話時間帯", value: "call_time", sortable: true },
        { text: "通話時間", value: "call_length", sortable: true },
        { text: "操作", value: "actions", sortable: false },
      ],
      calls: [],
      loading: false,
      totalCalls: 0,
      returnedCall: 0,
      options: {
        itemsPerPage: 10,
        page: 1,
      },
      selectedCalls: [],
      presignedUrlLoader: false,
      deleteDialog: false,
      deleteBulkDialog: false,
      selectedSessionId: "",
      isBulkDeleting: false,
      bulkDeleteTaskId: "",
      bulkDeleteInterval: null,
      recordingRefreshInterval: null,
      callIndexDownloadLoader: [],
      openSearchFilter: false,
      debouncedProcess: null,
      debounceInteractionUpdate: null,
      filters: {
        call_id: "",
        title: "",
        caller: "",
        receiver: "",
        counselor_name: "",
        dateRange: "",
        call_time: { start_date: "", end_date: "" },
        date: { start_date: "", end_date: "" },
        call_length: { start: "", end: "" },
        call_text: "",
        call_summary_text: "",
      },
      filterFields: [
        { label: "コールID", model: "call_id", icon: "mdi-account" },
        { label: "タイトル", model: "title", icon: "mdi-email" },
        { label: "発信者", model: "caller", icon: "mdi-phone" },
        { label: "通話テキスト", model: "call_text", icon: "mdi-message-text" },
        {
          label: "通話概要テキスト",
          model: "call_summary_text",
          icon: "mdi-text-box-search",
        },
        {
          label: "着信先",
          model: "receiver",
          icon: "mdi-city",
        },
        {
          label: "相談員氏名",
          model: "counselor_name",
          icon: "mdi-account-group",
        },
        {
          label: "クライアント名",
          model: "client_name",
          icon: "mdi-briefcase",
        },
        {
          label: "サービス名",
          model: "service_name",
          icon: "mdi-briefcase-outline",
        },
        { label: "日付範囲", model: "date", icon: "mdi-calendar" },
        { label: "通話時刻帯", model: "call_time", icon: "mdi-calendar" },
        // {
        //   label: "通話時間",
        //   model: "call_length",
        //   icon: "mdi-magnify",
        // },
      ],
      sortBy: "",
      sort_order: "",
      sortDesc: false,
      search_filter: {},
      openSearchResultList: false,
      onFocusOperatorSearch: true,
      selectedItems: [],
    };
  },

  watch: {
    options: {
      async handler(newVal, oldVal) {
        if (
          JSON.stringify(newVal.sortBy) !== JSON.stringify(oldVal.sortBy) ||
          JSON.stringify(newVal.sortDesc) !== JSON.stringify(oldVal.sortDesc)
        ) {
          if (newVal.sortBy[0] == "call_time") {
            this.sortBy = "start_time";
          } else {
            this.sortBy = newVal.sortBy[0];
          }
          this.sortDesc = newVal.sortDesc[0];
          this.sortDataFunction(newVal.sortBy[0]);
          await this.$nextTick();
        }

        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (!this.fullPageLoading) {
            this.getCallList();
          }
        }
      },
      deep: true,
    },
    userTags: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.deptOperators = this.getOperators();
          this.operators = this.getOperators();
        }
      },
    },
    async searchOperator() {
      if (this.searchOperator?.length > 0) {
        this.openSearchResultList = true;
      } else {
        this.openSearchResultList = false;
        return;
      }
      if (this.selectedItems?.length > 0) {
        this.operators = this.selectedItems;
      } else if (
        this.selectedItems?.length == 0 &&
        this.searchOperator?.length > 0
      ) {
        this.operators = this.getOperators();
      } else {
        this.operators = this.deptOperators.filter((operator) =>
          operator.dest_phone_name
            ?.toLowerCase()
            .includes(this.searchOperator?.toLowerCase())
        );
      }

      this.extraOperators = this.deptOperators.filter((operator) =>
        operator.dest_phone_name
          ?.toLowerCase()
          .includes(this.searchOperator?.toLowerCase())
      );
      await this.$nextTick();

      if (!this.extraOperators?.length > 0) {
        this.openSearchResultList = false;
      }
    },
    selectedOperator() {
      this.refreshCallList();
    },
    selectedCallStatus() {
      this.refreshCallList();
      interactionUpdate(INTERACTION_POINT.APPLY_FILTER, 'call_status_dropdown', this.selectedCallStatus || 'default');
    },
    activeProjectId() {
      // When switching project, reset selection and refresh the list for the new project.
      this.handleClear();
      this.refreshCallList();
    },
    searchText() {
      if (!this.searchText) {
        this.refreshCallList();
      }
    },
    toggleNaSwitch() {
      this.refreshCallList();
    },
  },
  mounted() {
    this.getOperators();
    this.recordingRefreshInterval = setInterval(() => {
      this.calls.forEach((call) => {
        if (!call.end_time) {
          this.$set(this.calls, this.calls.indexOf(call), { ...call });
        }
      });
    }, 1000); // Update every second
  },
  beforeUnmount() {
    if (this.recordingRefreshInterval) clearInterval(this.recordingRefreshInterval);
    if (this.bulkDeleteInterval) clearInterval(this.bulkDeleteInterval);
  },
  created() {
    this.debouncedProcess = debounce(this.refreshCallList, 500);
    this.debounceInteractionUpdate = debounce(
      () => {
        interactionUpdate(
          INTERACTION_POINT.APPLY_FILTER,
          "manual_search",
          JSON.stringify(this.search_filter) || "default"
        );
      },
      700
    );
  },
  methods: {
    handleClear() {
      this.searchOperator = "";
      this.operators = this.getOperators();
      this.selectedItems = [];
      this.selectedOperator = null;
    },
    async toggleSelection(item) {
      const index = this.selectedItems.findIndex(
        (selected) => selected.dest_phone_name === item.dest_phone_name
      );
      if (index === -1) {
        // Not found, add item
        this.selectedItems.push(item);
        const result = this.selectedItems.map((item) => item.dest_phone_name);
        this.selectedOperator = result;
        interactionUpdate(INTERACTION_POINT.SELECT_OPERATOR, 'side_nav', item.dest_phone_name || 'default');
      } else {
        // Found, remove item
        this.selectedItems.splice(index, 1); // Remove by match
        const result = this.selectedItems.map((item) => item.dest_phone_name);
        this.selectedOperator = result;
      }
      if (this.selectedItems?.length > 0 && this.searchOperator?.length > 0) {
        this.operators = this.selectedItems;
      } else {
        this.operators = this.getOperators();
      }
    },
    isSelected(item) {
      return this.selectedItems.some(
        (selected) => selected.dest_phone_name === item.dest_phone_name
      );
    },
    handleClickOutside(e) {
      const inputWrapper = this.$refs.searchInputWrapper?.$el;
      const listWrapper = this.$refs.searchListWrapper?.$el;
      const clickedInsideInput = inputWrapper?.contains(e.target);
      const clickedInsideList = listWrapper?.contains(e.target);

      const inputWrapperMobile = this.$refs.searchInputWrapperMobile?.$el;
      const listWrapperMobile = this.$refs.searchListWrapperMobile?.$el;
      const clickedInsideInputMobile = inputWrapperMobile?.contains(e.target);
      const clickedInsideListMobile = listWrapperMobile?.contains(e.target);
      if (
        !clickedInsideInput &&
        !clickedInsideList &&
        !clickedInsideInputMobile &&
        !clickedInsideListMobile
      ) {
        this.onFocusOperatorSearch = false;
        this.openSearchResultList = false;
      }
    },
    highlightMatch(text, query) {
      if (!query) return text;
      const regex = new RegExp(`(${query})`, "gi");
      return text.replace(regex, '<span class="highlight">$1</span>');
    },
    handleFocusSearch() {
      this.onFocusOperatorSearch = true;
      if (this.selectedItems?.length > 0 && this.searchOperator?.length > 0) {
        this.openSearchResultList = true;
      }
    },
    async getCallList() {
      this.loading = true;
      try {
        this.RETRIEVE_CALLS({
          call_status: this.selectedCallStatus,
          dest_phone_name: this.selectedOperator,
          search: this.searchText,
          start: (this.options.page - 1) * this.options.itemsPerPage || 0,
          size: this.options.itemsPerPage || 5,
          search_filter: this.search_filter,
          sort_field: this.sortBy,
          sort_order: this.sortDesc ? "desc" : "asc",
          toggleNaSwitch: this.toggleNaSwitch,
        }).then((response) => {
          if (response) {
            let update_bulk_data = [];
            this.calls = response.calls
              ? response.calls.map((call) => {
                const updatedCall = { ...call };
                let client_info = null;
                let counselor_name = null;
                let dest_patch = null;

                if (!updatedCall.client_info && updatedCall.sip_data) {
                  client_info = findClientsFromSipData(updatedCall.sip_data)?.[0] ?? null;

                  if (client_info) {
                    updatedCall.client_info = client_info;
                  }
                }

                const counselorBackfillPatch = getCounselorNameBackfillPatch(updatedCall);

                if (counselorBackfillPatch) {
                  const { counselor_name: patchedCounselorName, ...destOnlyPatch } = counselorBackfillPatch;

                  Object.assign(updatedCall, counselorBackfillPatch);

                  if (patchedCounselorName) counselor_name = patchedCounselorName;
                  if (Object.keys(destOnlyPatch).length) dest_patch = destOnlyPatch;
                }

                const data = {
                  ...(client_info && { client_info }),
                  ...(counselor_name !== null && counselor_name !== 'N/A' && { counselor_name }),
                  ...(dest_patch || {}),
                }
                if (Object.keys(data).length) {
                  update_bulk_data.push({
                    session_id: updatedCall.session_id,
                    ...data,
                  });
                }
                return updatedCall;
              })
              : [];

            if (update_bulk_data.length > 0) {
              this.UPDATE_BULK_CALL_DETAILS(update_bulk_data).catch((error => {
                console.error('Error updating bulk call details:', error);
              }));
            }

            this.userTags = response.access_tags || [];
            this.totalCalls = response.total_hits;
            this.returnedCall = response.returned_hits;
            this.callIndexDownloadLoader = response.calls.map(() => false);
          }
          this.loading = false;
        });
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    getOperators() {
      // If no tags, return all
      if (this.userTags.length === 0) {
        this.operators = dest_info;
        this.deptOperators = dest_info;
        return dest_info;
      }

      // Filter operators by any matching tag (case-insensitive)
      const filterOperators = dest_info.filter((operator) =>
        this.userTags.some((tag) =>
          operator.dest_phone_name?.toLowerCase().includes(tag.toLowerCase())
        )
      );
      this.operators = filterOperators;
      this.deptOperators = filterOperators;
      return filterOperators
    },
  },
};
</script>

<style scoped>
.main-div {
  display: flex;
  background-color: #0b131c;
}
.disabled {
  color: #cccccc;
}

.app-bar {
  background-color: #0b131c;
  color: white;
  height: 100vh;
  width: 200px;
  overflow-y: hidden;
  padding: 20px 0px 20px 20px;
}
.mobile-drawer {
  background-color: #0b131c !important;
  width: 280px !important;
  z-index: 50;
  height: 100vh !important;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.mobile-operator-search-main {
  height: calc(100vh - 80px) !important;
  overflow-y: auto;
}

.mobile-operator-list {
  max-height: none !important;
  height: auto !important;
}

.mobile-header {
  background-color: #0b131c;
  color: white;
  border-bottom: 1px solid #3f4652;
}

.operator-dropdown {
  display: none;
}
.operator-search {
  border-radius: 12px;
  width: 90%;
  background: #ffffff14;
}
.v-input__control {
  border-radius: 12px;
}
.operator-list {
  background-color: transparent;
  overflow-y: auto;
  max-height: calc(100vh - 180px);
  scrollbar-color: #3f4652 #0b131c;
  scrollbar-width: thin;
  width: 100%;
  padding-right: 20px;
}
.operator-list-item {
  cursor: pointer;
  background-color: transparent;
  border: 0.3px solid #3f4652;
  border-radius: 12px;
  height: 42px;
  padding: 0 16px;
  margin: 6px 0;
}
.main-section {
  width: calc(100% - 200px);
  height: 100vh;
  padding: 0px;
  margin: 8px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  position: relative;
}

.mobile-main-section {
  width: 100%;
  height: 100vh;
  margin: 0;
  border-radius: 0;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  left: 50%;
  right: 50%;
  transform: translateX(-50%);
  width: 100%;
  background: white;
  border-top: 1px solid #e2e8f0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 8px 8px;
}
.main-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.table-title {
  font-size: 16px;
  font-weight: 500;
  color: #194fa2;
  margin: 0;
  padding: 0;
}
.table-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #3f4652;
  margin: 0;
  padding: 0;
}
.search-call {
  width: 200px;
  height: 40px;
  border-radius: 8px;
  padding: 0 16px;
  border-width: 0.5px;
  background: #ffffff33;
  border: 0.5px solid #cccccc;
  backdrop-filter: blur(20px);
}
.call-filter {
  width: 200px;
  height: 40px;
  border-radius: 8px;
  padding: 0 16px;
  border-width: 0.5px;
  background: #ffffff33;
  border: 0.5px solid #cccccc;
  backdrop-filter: blur(20px);
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23222222'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}
.call-filter-list {
  padding: 5px;
  background: white;
}
.table-more-options {
  padding: 5px;
  background: white;
}
.delete-dialog {
  border-radius: 16px !important;
  padding: 24px 24px 32px 24px !important;
  border: 4px solid #e2e8f0 !important;
  box-shadow: 0px 0px 20px 0px #1e1e1e05;
  backdrop-filter: blur(20px);
}
.delete-dialog-text {
  font-size: 15px;
  font-weight: 400;
  color: #3f4652;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px !important;
}
.no-btn-delete {
  width: 30% !important;
  border-radius: 6px !important;
  border-width: 1px !important;
  background-color: #e4e4e4 !important;
  color: #3f4652 !important;
  box-shadow: none !important;
}
.yes-btn-delete {
  width: 30% !important;
  border-radius: 6px !important;
  background-color: #ef3939 !important;
  color: white !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
  .main-div {
    flex-direction: column;
  }
  .app-bar {
    display: none;
  }
  .operator-dropdown {
    display: block;
  }
  .operator-list {
    max-height: 100px;
  }
  .main-section {
    width: 100%;
    height: calc(100vh - 20px);
    margin: 10px 0;
  }
  .main-header {
    flex-direction: column;
  }
  .footer-fixed {
    flex-direction: column;
    align-items: center;
  }
}
.extra-list-overlay {
  position: absolute;
  top: 50px; /* adjust to appear where you want */
  left: 50px;
  background-color: white;
  z-index: 9999;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.custom-table-checkbox >>> .v-data-table__checkbox {
  transform: scale(0.8);
}
</style>
